import { makeAutoObservable } from "mobx";
import { Subject } from "rxjs";
import {
  IAPIPaginationResponse,
  PaginationModel,
} from "@mindmemobile/mm-shared-global";
import { ContactDetailModel, ContactDetailPageModel, ContactGridModel, ContactReferenceModel } from "../models/ContactDetailPageModel";
import { IAPIContactDetailPageModel, IAPIContactGridModel } from "../interfaces/IAPIContactModels";

export default class ContactStore {
  public detailPage: ContactDetailPageModel | null = null;
  public gridData: ContactGridModel[] = [];
  public pagination: PaginationModel = new PaginationModel({ pageSize: 10 });
  public searchSubject = new Subject<boolean>();
  public searchValue: string = '';
  public showFilter: boolean = false;
  public selectedContactDetails: ContactReferenceModel | null = null;
  constructor() {
      makeAutoObservable(this);
  }

  toggleFilter(): void {
      this.showFilter = !this.showFilter;
  }

  updateSearchValue(value: string): void {
      this.searchValue = value;
      this.pagination = new PaginationModel({ pageNumber: 1, pageSize: 10 });
      this.searchSubject.next(true);
  }

  deserializeDetailPage(data: IAPIContactDetailPageModel|null): void {
      this.detailPage = ContactDetailPageModel.deserializeAPIModel(data);
  }

  deserializeGridData(data: IAPIContactGridModel[], pagination: IAPIPaginationResponse): void {
      this.gridData = data?.map((item) => ContactGridModel.deserializeAPIModel(item)) || [];
      this.pagination = PaginationModel.deserialize(pagination);
  }

  setSelectedContactDetails(detail: ContactDetailModel): void {
      this.selectedContactDetails = new ContactReferenceModel({
          id: detail.id,
          firstName: detail.firstName,
          lastName: detail.lastName,
          email: detail.homeEmail || detail.workEmail || detail.otherEmail || '',
          workEmail: detail.workEmail,
          otherEmail: detail.otherEmail,
          homePhone: detail.homePhone,
          workPhone: detail.workPhone,
          otherPhone: detail.otherPhone,
          createdDate: detail.createdDate,
      });
  }
}

